import React from "react";
import WaybillTemplateType from "@/enum/WaybillTemplateType";
import { Form } from "antd";
import { PrintWaybillFormValues } from "./PrintWaybillForm";
import { MultiShopSelectPlatformType } from "@/components/MultiShopSelect/types";
import { UseChildWaybillModeFormItem } from "@/scenes/OrderManagement/components/dialogs/PrintWaybillDialog/components/CopiesFormItems/UseChildWaybillModeFormItem";

interface MultiPlatformUseChildWaybillNoModeFormItemProps {
    platform: MultiShopSelectPlatformType;
}

/*  
是否使用子母单选项
如果选择的份数>2时，并且该模板是电子面单模板并支持子母单模式（WaybillTemplate.supportsChildWaybillNoMode）打印时，
在份数右边通过checkbox让用户选择是否使用子母单打印。注：子母单模式是多个包裹共用一个主运单号，并合并重量按一个包裹计费 
*/
const MultiPlatformUseChildWaybillNoModeFormItem: React.FC<MultiPlatformUseChildWaybillNoModeFormItemProps> = function (
    props,
) {
    const { platform } = props;

    return (
        <Form.Item<PrintWaybillFormValues>
            noStyle
            shouldUpdate={(prev, next) => {
                return prev.copies !== next.copies || prev[platform]?.template !== next[platform]?.template;
            }}
        >
            {(form) => {
                const values = form.getFieldsValue();

                const copies = values.copies;

                const childFormItemInfo = values[platform];

                const template = childFormItemInfo?.template;

                // 非电子面单不支持子母单，并且电子面单要支持子母单模式
                if (!template || !template.supportsChildWaybillNoMode) return null;

                if (template.type === WaybillTemplateType.NORMAL) return null;

                // 小于2支持子母单打印
                const num = copies;

                if (Number.isNaN(num) || (num as number) < 2) return null;

                return (
                    <Form.Item colon={false} label=" ">
                        <UseChildWaybillModeFormItem
                            // @ts-ignore
                            form={form}
                            name={[platform, "useChildWaybillNoMode"]}
                            template={template}
                        />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};

export default React.memo(MultiPlatformUseChildWaybillNoModeFormItem);
